export default "__VITE_ASSET__BKk1u6Gr__"